module.exports = __webpack_public_path__ + "img/drive-vil-1.1ad3414c.svg";